<template>
    <div class="optional-select row">
        <div class="col">
            <label :for="id">
                <div class="custom-checkbox-title">{{ label }}</div>
                <div class="custom-checkbox-subtitle">{{ subtitle }}</div>
            </label>
        </div>
        <div class="col text-right">
            <select :value="modelValue" @input="handleChange" :id="id">
                <option v-for="option in options" :key="option.value" :value="option.value">{{ option.label }}</option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OptionalSelect',
    model: {
        prop: 'modelValue',
        event: 'change',
    },
    props: {
        modelValue: {
            default: -1,
        },
        id: {
            type: String,
            required: false,
            default() {
                return 'checkbox_' + Math.random().toString(36).substring(2, 8) + Math.random().toString(36).substring(2, 8);
            }
        },
        label: {
            type: String,
            default() {
                return null
            }
        },
        subtitle: {
            type: String,
            default() {
                return null
            }
        },
    },
    data() {
        return {
            options: [
                {
                    label: "Don't Care",
                    value: '-1',
                },
                {
                    label: "Yes",
                    value: '1',
                },
                {
                    label: "No",
                    value: '0',
                },
            ],
        }
    },
    methods: {
        handleChange(e) {
            this.$emit('change', e.target.value)
        }
    },
};
</script>

<style lang="scss">
.optional-select {
    label {
        position: relative;
        cursor: pointer;
        
        .custom-checkbox-title {
            font-size: 15px;
        }
        .custom-checkbox-subtitle {
            font-size: 12px;
            font-weight: lighter;
            margin-top: -3px;
        }
    }
    select {
        border: 1px solid $dark-gray;
        border-radius: 4px;
        padding: 4px 25px 4px 9px;
        appearance: none;
        background: url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I0Y5RjlGOTt9LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNC45NSIgaGVpZ2h0PSIxMCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxLjQxIDQuNjcgMi40OCAzLjE4IDMuNTQgNC42NyAxLjQxIDQuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMy41NCA1LjMzIDIuNDggNi44MiAxLjQxIDUuMzMgMy41NCA1LjMzIi8+PC9zdmc+) no-repeat;
        background-position: right 5px top;
        color: $darker-gray;
    }
}
</style>